import React from 'react';
import './style.css';
import logo from '../../assets/images/logo.png';
import contactIcon1 from '../../assets/images/footer/iccon_adress.png';
import contactIcon2 from '../../assets/images/footer/icon_mail.png';
import contactIcon3 from '../../assets/images/footer/icon_tel.png';

import iconFb from '../../assets/images/footer/icon_fb.png';
import iconTwitter from '../../assets/images/footer/icon_twit.png';
import iconGoogle from '../../assets/images/footer/icon_google.png';
import iconYoutube from '../../assets/images/footer/icon_youtube.png';

class Footer extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      showContent: false,
      homeData: {},
    };
  }

  componentDidMount() {}

  UNSAFE_componentWillReceiveProps(nextProps) {}

  render() {
    return (
      <footer className='app-footer'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-5'>
              <div className='footer-col-1'>
                <img className='img-fluid footer-logo' src={logo} alt='logo' style={{width: 111}}/>
                <ul className='contact-list'>
                  <li className='contact-item'>
                    <img src={contactIcon1} alt='contact-icon' />
                    <div className='contact-infor'>
                      <span>Tầng 5 - Tháp B2 Tòa nhà Roman Plaza - Tố Hữu</span><br/>
                       <span>Nam Từ Liêm - Hà Nội</span>
                    </div>
                  </li>
                  <li className='contact-item'>
                    <img src={contactIcon2} alt='contact-icon' />
                    <div className='contact-infor'>lienhe@timesschools.com.vn</div>
                  </li>
                  <li className='contact-item'>
                    <img src={contactIcon3} alt='contact-icon' />
                    <div className='contact-infor'>024 56 78 96 69</div>
                  </li>
                </ul>
              </div>
            </div>
            <div className='col-md-4'>
              <div className='footer-col-2'>
                <h5 className='footer-title'>Quản lý dịch vụ trường học</h5>
                <ul className='basic-ul text-left'>
                  <li>
                    <a href=''>Quản lý tuyển sinh</a>
                  </li>
                  <li>
                    <a href=''>Quản lý trường học</a>
                  </li>
                  <li>
                    <a href=''>Quản lý dịch vụ học đường</a>
                  </li>
                  <li>
                    <a href=''>Quản lý cơ sở vật chất</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className='col-md-3'>
              <div className='footer-col-3'>
                <h5 className='footer-title text-left'>Khác</h5>
                <ul className='basic-ul text-left'>
                  <li>
                    <a href=''>Hướng dẫn sử dụng</a>
                  </li>
                  <li>
                    <a href=''>Thỏa thuận sử dụng dịch vụ</a>
                  </li>
                  <li>
                    <a href=''>Chính sách bảo mật</a>
                  </li>
                </ul>
                <h5 className='footer-title second-title text-left'>Tuyển dụng</h5>
                <div className='social d-flex'>
                  <a href=''>
                    <img src={iconFb} alt='fb' style={{height: 24}} />
                  </a>
                  <a href=''>
                    <img src={iconTwitter} alt='fb' />
                  </a>
                  <a href=''>
                    <img src={iconGoogle} alt='fb' />
                  </a>
                  <a href=''>
                    <img src={iconYoutube} alt='fb' />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
